import { Content } from '../../interfaces/RepaymentHistory.type';
import { ACTIVE_ROW_INDEX, BANK_LENGTH_WORD_LIMIT, MANDATE } from './const';

export const assignIndexToRepaymentList = (repaymentHistory: Content[] = []) => {
  let activeRowIndex = ACTIVE_ROW_INDEX;

  return repaymentHistory.map((repayment, index) => {
    if (repayment.toggleState) activeRowIndex = index;
    const currentRowIndex = index <= activeRowIndex ? index + 1 : index;

    return { ...repayment, index: currentRowIndex };
  });
};

export const isBankNameLong = (bankName: string) => {
  return bankName?.length > BANK_LENGTH_WORD_LIMIT;
};

export const isAccountTypeMandate = (instrumentType: string[]) => {
  return instrumentType?.includes(MANDATE);
};

export const convertToTitleCase = (input: string | null | undefined): string => {
  if (!input || !input.trim()) return '';

  const words = input.trim().split('_').join(' ');

  return words;
};
